export const getSupervisorDepartmentIds = (userInfo, departments = []) => {
	if(!userInfo || `${userInfo.role_id}` !== '3') return [];

	const user_id = `${userInfo.user_id || ''}`;
	return (Array.isArray(departments) ? departments : []).reduce((results, department) => {
		const supervisors = Array.isArray(department.supervisors) ? department.supervisors : [];
		if(supervisors.some(supervisor => `${supervisor.user_id || ''}` === user_id)) results.push(department.department_id);
		return results;
	}, []);
};

export const buildSupervisorScope = ({
	userInfo,
	departments = [],
	courses = [],
	teachers = [],
	classrooms = [],
	sections = [],
}) => {
	const isSupervisor = !!userInfo && `${userInfo.role_id}` === '3';
	const departmentIds = getSupervisorDepartmentIds(userInfo, departments);
	const departmentIdSet = new Set(departmentIds.map(department_id => `${department_id}`));
	const hasSupervisorDepartment = (department_ids = []) => (
		Array.isArray(department_ids) && department_ids.some(department_id => departmentIdSet.has(`${department_id}`))
	);

	const courseIds = (Array.isArray(courses) ? courses : [])
		.filter(course => hasSupervisorDepartment(course.departments))
		.map(course => course.course_id);
	const courseIdSet = new Set(courseIds.map(course_id => `${course_id}`));

	const teacherIds = (Array.isArray(teachers) ? teachers : [])
		.filter(teacher => hasSupervisorDepartment(teacher.departments))
		.map(teacher => teacher.teacher_id);
	const teacherIdSet = new Set(teacherIds.map(teacher_id => `${teacher_id}`));

	const classroomIds = (Array.isArray(classrooms) ? classrooms : [])
		.filter(classroom => hasSupervisorDepartment(classroom.departments))
		.map(classroom => classroom.classroom_id);
	const classroomIdSet = new Set(classroomIds.map(classroom_id => `${classroom_id}`));

	const sectionIsInScope = (section = {}) => (
		courseIdSet.has(`${section.course_id}`) ||
		teacherIdSet.has(`${section.teacher_id}`) ||
		(Array.isArray(section.secondary_teachers) && section.secondary_teachers.some(teacher_id => teacherIdSet.has(`${teacher_id}`)))
	);

	const visibleSections = (Array.isArray(sections) ? sections : []).filter(sectionIsInScope);

	return {
		isSupervisor,
		departmentIds,
		departmentIdSet,
		courseIds,
		courseIdSet,
		teacherIds,
		teacherIdSet,
		classroomIds,
		classroomIdSet,
		hasSupervisorDepartment,
		sectionIsInScope,
		visibleDepartments: isSupervisor ? departments.filter(department => departmentIdSet.has(`${department.department_id}`)) : departments,
		visibleCourses: isSupervisor ? courses.filter(course => courseIdSet.has(`${course.course_id}`)) : courses,
		visibleTeachers: isSupervisor ? teachers.filter(teacher => teacherIdSet.has(`${teacher.teacher_id}`)) : teachers,
		visibleClassrooms: isSupervisor ? classrooms.filter(classroom => classroomIdSet.has(`${classroom.classroom_id}`)) : classrooms,
		visibleSections: isSupervisor ? visibleSections : sections,
	};
};
